import { forwardRef } from "react";

import {
  type THeaderMenuToggleElement,
  type THeaderMenuToggleProps,
} from "@/ui/components/navigation/Header/Header.config";
import {
  HeaderMenuToggleIcon,
} from "@/ui/components/navigation/Header/HeaderMenuToggleIcon";
import { cn } from "@/ui/lib/utils";

export const HeaderMenuToggle = forwardRef<
  THeaderMenuToggleElement,
  THeaderMenuToggleProps
>(({ className, open, ...props }, ref) => (
  <span
    {...props}
    ref={ref}
    aria-hidden="true"
    data-component="HeaderMenuToggle"
    className={cn(
      "relative inline-flex w-11 h-11 items-center justify-center",
      className,
    )}
  >
    <HeaderMenuToggleIcon className="size-full" open={open} />
  </span>
));

HeaderMenuToggle.displayName = "HeaderMenuToggle";
